import { registerMicroApps, start } from 'qiankun'
import { MICRO_APP_CONFIG } from './microAppConfig'
import './qiankun/globalStateActions'
import { reloadIframeBySubAppUrl } from './messageBus'
import { getRouter } from '@/router'
import storeInstance from '@/store'
import { getBaseAppProtocolHost, isUrlEqual, routerChangeTrigger } from './utils'
import { CONFIG_ENV_APP_INFO_DICT, curEnvConfigAppInfoDict, menuUrlReplacePat } from './config'

function startMicroAppQiankun(baseConfig) {
  const qiankunMicroAppConfig = MICRO_APP_CONFIG.filter(item => item.type === 'qiankun').map(item => {
    return {
      ...item,
      ...baseConfig,
    }
  })
  registerMicroApps(qiankunMicroAppConfig)

  if (!window.qiankunStarted) {
    start()
    window.qiankunStarted = true
  }
}

export function startMicroApp(baseConfig) {
  startMicroAppQiankun(baseConfig)
}

export function findMicroAppConfig(path) {
  return MICRO_APP_CONFIG.find(item => String(path).startsWith(item.activeRule))
}

export function findMicroAppConfigBySubAppEntry(entry) {
  return MICRO_APP_CONFIG.find(item => String(entry) === item.entry)
}

export function isMicroApp(path) {
  return MICRO_APP_CONFIG.some(item => String(path).startsWith(item.activeRule))
}

export function isMicroAppIframe(path) {
  const item = findMicroAppConfig(path)
  return item && item.type === 'iframe'
}

export function isMicroAppQiankun(path) {
  const item = findMicroAppConfig(path)
  return item && item.type === 'qiankun'
}

/**
 * 主应用的 url 转换成 子应用的 url
 * @param {*} url
 * @param {*} microAppConfig
 */
export function baseUrlToIframeMicroUrl(url) {
  const { pathname } = new URL(url)
  const microAppConfig = findMicroAppConfig(pathname)

  if (!microAppConfig) {
    throw new Error(`pathName: ${pathname} 对应的 microApp 不存在`)
  }
  if (microAppConfig.type === 'qiankun') {
    throw new Error(`pathName: ${pathname} 对应的 microApp 是 qiankun 类型的, 不需要转换`)
  }

  if (!microAppConfig.entry) {
    // todo 当没有 entry 的时候, 说明当前主环境没有对应的子环境, 需要跳转
    return ''
  }

  return url.replace(new RegExp(`.*?${microAppConfig.activeRule}`), microAppConfig.entry)
}

export function subAppUrlToBaseUrl(subAppUrl) {
  // http://localhost:9000/#/finance/profitStatement
  // http://localhost:8000/s/bi/#/finance/profitStatement
  const { protocol, host } = new URL(subAppUrl)
  const subAppEntry = protocol + '//' + host
  const microAppConfig = findMicroAppConfigBySubAppEntry(subAppEntry)
  console.log(subAppUrl, '立即注册')

  // if (subAppEntry === 'https://kj.qizhishangke.com' && subAppUrl.includes('entry')) {
  //   window.open(subAppUrl)
  // }

  if (!microAppConfig) {
    throw new Error(`subAppEntry: ${subAppEntry} 对应的 microApp 不存在`)
  }
  if (microAppConfig.type === 'qiankun') {
    throw new Error(`pathsubAppEntryName: ${subAppEntry} 对应的 microApp 是 qiankun 类型的, 不需要转换`)
  }

  return subAppUrl.replace(new RegExp(`.*?${subAppEntry}`), getBaseAppProtocolHost() + microAppConfig.activeRule)
}

export function setupMainApp({ getRouter }) {
  // 拦截 base-app 路由变化, 用于确定当前标签
  getRouter().afterEach(route => {
    storeInstance.dispatch('pageTag/updateBaseAppUrl')
  })
}

export const menuListUrlToBaseApp = (list = []) => {
  const replacePat = menuUrlReplacePat
  return list.map(menu => {
    const { path, children, ...rest } = menu
    const ret = {
      ...rest,
    }

    if (path) {
      for (let index = 0; index < replacePat.length; index++) {
        const { pat, replacement } = replacePat[index]
        if (path.indexOf(pat) !== -1) {
          ret.path = path.replace(pat, replacement)
          break
        }
      }
    }

    if (Array.isArray(children)) {
      ret.children = menuListUrlToBaseApp(children)
    }

    return ret
  })
}

export function reloadIframeByBaseAppUrl(baseAppUrl, tag) {
  const subAppUrl = baseUrlToIframeMicroUrl(baseAppUrl)
  reloadIframeBySubAppUrl(subAppUrl, tag)
}

/**
 * 去跳转融合的erp首页
 */
export function getJumpFusionErpHome() {
  const erpHomeUrl = curEnvConfigAppInfoDict?.erp?.entry || 'https://erp.qizhishangke.com'
  return erpHomeUrl
}

// 主入口
// 主入口
// 主入口
// 主入口
// 主入口
setupMainApp({
  getRouter,
})

export * from './utils'
export { syncRouteToBaseApp } from './pageTagUtils'
